<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
                <v-card title>
                    <v-card-title>
                        <h2>Periodos</h2>
                    </v-card-title>
                    <v-card-text>
                        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <PeriodoDialog v-if="get_dialogMain.dialog" />
        <AssignSurveytoPeriodoDialog v-if="get_dialogSecoundMain.dialog" :model="periodo" />

</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import PeriodoDialog from '@/components/dialogs/PeriodoDialog'
import AssignSurveytoPeriodoDialog from '@/components/dialogs/AssignSurveytoPeriodoDialog'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'period.store' }
        ],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Fecha Inicial', value: 'fecha_inicial', class: 'black--text' },
          { text: 'Fecha Final', value: 'fecha_final', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'asignar Encuesta', icon: 'mdi-clipboard-check', color: 'lime lighten-1', action: 'toAssignSurvey', code: 'survey.periodo' }
        ]
      },
      footer: {
        paging: true
      }
    },
    periodo: {}
  }),
  components: {
    DataTableMain,
    PeriodoDialog,
    AssignSurveytoPeriodoDialog
  },
  mounted () {
    this.ShowPermisos(JSON.parse(localStorage.getItem('permisos')))
    this.getUrl('period.show')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('period.show')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    toAssignSurvey (item) {
      this.periodo = item.item
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create' })
    },
    ...mapActions(['getUrlServices', 'postUrlServicesListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesListAction({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    ShowPermisos (permisos) {
      if (permisos.descripcion) {
        if (permisos.descripcion.special === 'all-access') {
          this.table.header.options.map(action => {
            action.hidden = ''
          })
          this.table.body.actions.map(action => {
            action.hidden = ''
          })
        } else {
          this.table.header.options.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })

          this.table.body.actions.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })
        }
      } else {
        this.table.header.options.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })

        this.tableServer.body.actions.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_SECOUND_MAIN', 'CLEAR_DATAS_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_dialogSecoundMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('period.show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATAS_MAIN()
  }

}
</script>

<style>

</style>
